<ng-template #windowTemplate>
    <div id="full-window-call-center">
        <div class="w-100 h-100"
            *ngIf="!twilioService.disabled">
            <app-inline-menu
                (menuClicked)="activateTab = $event.id"
                [menuItems]="tabMenuItems"></app-inline-menu>
            <div class="call-cont mt-4"
                 *ngIf="!twilioService.disabled"
                 style="height: calc(100% - 120px)">
                <div class="tab-content h-100">
                    <!-- Dialer -->
                    <div
                        class="tab-pane h-100"
                        [ngClass]="{ active: activeTabI[0] }"
                        @fadeInOut>
                        <!--<div class="flex-sm-fill text-sm-end window-actions p-3 bg-white br-t-8">
                            <svg-icon
                                src="assets/images/call/window-_.svg"
                                *ngIf="twilioService.isLineBusy"
                                (click)="callCenterMode = 'bar-style'"></svg-icon>
                            <svg-icon
                                src="assets/images/call/window-float.svg"
                                (click)="callCenterMode = 'floating-window'"
                                class="mx-2"></svg-icon>
                            <svg-icon
                                src="assets/images/call/window-x.svg"
                                (click)="callCenterMode = 'none'"></svg-icon>
                        </div>-->

                        <div class="mh-100 text-start h-100">
                            <div class="row g-0 mb-2">
                                <div class="col col-xl-8 pe-2">

                                    <div class="row mb-2">
                                        <div class="col col-xl-6 pe-xl-1">
                                            <div class="card bg-white border-0 h-100">
                                                <div class="card-body d-flex flex-column">
                                                    <div class="fs-6 text-muted">Online agents</div>
                                                    <div class="fs-2 fw-bold mt-auto">
                                                        <span *ngIf="callStats">{{ callStats?.onlineAgents }}</span>
                                                        <app-inline-spinner [isVisible]="!callStats"></app-inline-spinner>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col col-xl-6 ps-xl-1">
                                            <div class="card bg-white border-0 h-100">
                                                <div class="card-body d-flex flex-column">
                                                    <div class="fs-6 text-muted">Active calls</div>
                                                    <div class="fs-2 fw-bold mt-auto">
                                                        <span *ngIf="callStats">{{ callStats.activeCalls }}</span>
                                                        <app-inline-spinner [isVisible]="!callStats"></app-inline-spinner>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row mb-2">
                                        <div class="col col-xl-6 pe-xl-1">
                                            <div class="card bg-white border-0 h-100">
                                                <div class="card-body d-flex flex-column">
                                                    <div class="fs-6 text-muted">Inbound/Outbound calls</div>
                                                    <div class="fs-2 fw-bold mt-auto">
                                                        <span *ngIf="callStats">{{ callStats.inboundCalls }}/{{ callStats.outboundCalls }}</span>
                                                        <app-inline-spinner [isVisible]="!callStats"></app-inline-spinner>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col col-xl-6 ps-xl-1">
                                            <div class="card bg-white border-0 h-100">
                                                <div class="card-body d-flex flex-column">
                                                    <div class="fs-6 text-muted">Wait time/average</div>
                                                    <div class="fs-2 fw-bold mt-auto">
                                                        <span *ngIf="callStats">{{ callStats.waitTime }}/{{ callStats.averageWaitTime }}</span>
                                                        <app-inline-spinner [isVisible]="!callStats"></app-inline-spinner>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row mb-2">
                                        <div class="col col-xl-6 pe-xl-1">
                                            <div class="card bg-white border-0 h-100">
                                                <div class="card-body d-flex flex-column">
                                                    <div class="fs-6 text-muted">Callbacks</div>
                                                    <div class="fs-2 fw-bold mt-auto">
                                                        <span *ngIf="callStats">{{ callStats.callbacks }}</span>
                                                        <app-inline-spinner [isVisible]="!callStats"></app-inline-spinner>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col col-xl-6 ps-xl-1">
                                            <div class="card bg-white border-0 h-100">
                                                <div class="card-body d-flex flex-column">
                                                    <div class="fs-6 text-muted">Voice messages</div>
                                                    <div class="fs-2 fw-bold mt-auto">
                                                        <span *ngIf="callStats">{{ callStats.voiceMessages }}</span>
                                                        <app-inline-spinner [isVisible]="!callStats"></app-inline-spinner>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div class="col col-xl-4 bg-white br-b-8 mb-2 pt-2">
                                    <h6 class="fs-5 mb-0">Available agents</h6>
                                    <small>Total admins: {{ callStats?.availableAgents }}</small>
                                    <div class="header px-3 py-2">
                                        <input
                                                type="search"
                                                placeholder="Search by Name or Phone Number"
                                                class="search-text-input my-1"
                                                [ngClass]="{ loading: agentsList.length === 0 }"
                                                [(ngModel)]="agentFilter"
                                                (keyup)="filterAgentListDebounce(this.agentsList)"
                                                (keyup.enter)="filterAgentList(this.agentsList)" />
                                    </div>
                                    <div class="flex-grow-1 px-3 py-2 agent-list-cont">

                                        <ng-container *ngFor="let agent of filteredAgentsList">
                                            <div class="d-flex w-100" (click)="makeACallAdmin(agent)">
                                                <app-avatar
                                                        [user]="agent"
                                                        [fontSize]="'14px'"
                                                        [fontWeight]="'600'"
                                                        [showIcons]="false"
                                                        [onlineCb]="availableForInboundAgentCb"></app-avatar>
                                                <div class="d-flex flex-column flex-grow-1 justify-content-center ms-2">
                                                    <p class="m-0">{{ agent.firstname }} {{ agent.surname }}</p>
                                                    <small>{{ agent.accountType }}</small>
                                                </div>
                                            </div>
                                        </ng-container>

                                    </div>
                                </div>
                            </div>

                            <div class="row g-0" style="height: calc(100% - 340px)">
                                <div class="col col-xl-8 br-b-8 h-100">
                                    <div class="p-3 me-2 bg-white h-100">
                                        <h6 class="fs-5 mb-0">Live calls table</h6>
                                        <small>Online call now: {{ callStats?.liveCalls }}</small>
                                        <app-table *ngIf="tableConfig" style="height: calc(100% - 36px);display: block"
                                                   [tableConfig]="tableConfig"
                                        ></app-table>
                                        <app-inline-spinner [isVisible]="!tableConfig"></app-inline-spinner>
                                    </div>
                                </div>
                                <div class="col col-xl-4 bg-white br-b-8">
                                    <div class="flex-sm-fill text-sm-end window-actions p-3 bg-white br-t-8">
                                        <svg-icon
                                                src="assets/images/call/window-_.svg"
                                                *ngIf="twilioService.isLineBusy"
                                                (click)="callCenterMode = 'bar-style'"></svg-icon>
                                        <svg-icon
                                                src="assets/images/call/window-float.svg"
                                                (click)="callCenterMode = 'floating-window'"
                                                class="mx-2"></svg-icon>
                                        <svg-icon
                                                src="assets/images/call/window-x.svg"
                                                (click)="callCenterMode = 'none'"></svg-icon>
                                    </div>
                                    <app-dialpad></app-dialpad>
                                </div>
                            </div>
                        </div>



                    </div>
                    <div
                        class="tab-pane bg-white h-100"
                        [ngClass]="{ active: activeTabI[1] }"
                        @fadeInOut>
                        <app-calls-history></app-calls-history>
                    </div>
                    <div
                        class="tab-pane bg-white h-100"
                        [ngClass]="{ active: activeTabI[2] }"
                        @fadeInOut>
                        <app-calls></app-calls>
                    </div>
                    <div
                        class="tab-pane bg-white h-100"
                        [ngClass]="{ active: activeTabI[3] }"
                        @fadeInOut>
                        <app-calls-recordings></app-calls-recordings>
                    </div>
                    <div
                            class="tab-pane bg-white h-100"
                            [ngClass]="{ active: activeTabI[4] }"
                            @fadeInOut>
                        <app-calls-recordings recordingSource="RecordVerb"></app-calls-recordings>
                    </div>
                    <div
                        class="tab-pane"
                        [ngClass]="{ active: activeTabI[5] }"
                        @fadeInOut>
                        <app-calls-settings></app-calls-settings>
                    </div>
                </div>
            </div>
        </div>
        <ng-template [ngTemplateOutlet]="orderDetailsTmpl"></ng-template>
        <ng-template [ngTemplateOutlet]="availableAgentsList"></ng-template>
        <ng-template [ngTemplateOutlet]="newCallNote"></ng-template>
        <ng-template [ngTemplateOutlet]="callNotes"></ng-template>
    </div>
</ng-template>
<ng-template #barTemplate>
    <div class="position-relative">
        <app-call-bar [controllingComponent]="this"></app-call-bar>
        <ng-template [ngTemplateOutlet]="orderDetailsTmpl"></ng-template>
        <ng-template [ngTemplateOutlet]="availableAgentsList"></ng-template>
    </div>
</ng-template>
<ng-template #floatTemplate>
    <div
        id="floating-call-center"
        #cdkDrag="cdkDrag"
        cdkDrag
        [cdkDragFreeDragPosition]="dragPosition"
        [cdkDragBoundary]="'body'"
        [ngClass]="{
            sm: (callDetails$ | async)?.showOrderDetails,
            'sm--top':
                (callDetails$ | async)?.showAvailableAgents ||
                (callDetails$ | async)?.showNewCallNote ||
                (callDetails$ | async)?.showCallNotes
        }"
        (click)="floatClicked($event)">
        <div
            class="nav nav-pills flex-column flex-sm-row"
            cdkDragHandle>
            <ng-container
                *ngIf="
                    !(callDetails$ | async)?.showOrderDetails &&
                    !(callDetails$ | async)?.showAvailableAgents &&
                    !(callDetails$ | async)?.showNewCallNote &&
                    !(callDetails$ | async)?.showCallNotes
                ">
                <button
                    class="btn-styled btn-tab text-sm-center"
                    [ngClass]="{ active: activeFloatTabI[0] }"
                    (click)="activeFloatTabI = [1, 0, 0]">
                    Dialer
                </button>
                <button
                    class="btn-styled btn-tab text-sm-center"
                    [ngClass]="{ active: activeFloatTabI[1] }"
                    (click)="activeFloatTabI = [0, 1, 0]">
                    Calls
                </button>
                <button
                    class="btn-styled btn-tab text-sm-center"
                    [ngClass]="{ active: activeFloatTabI[2] }"
                    (click)="activeFloatTabI = [0, 0, 1]">
                    Contacts
                </button>
            </ng-container>
            <div class="flex-sm-fill text-sm-end window-actions">
                <svg-icon
                    src="assets/images/call/window-_.svg"
                    *ngIf="twilioService.isLineBusy"
                    (click)="callCenterMode = 'bar-style'"></svg-icon>
                <svg-icon
                    src="assets/images/call/window-inline.svg"
                    (click)="callCenterMode = 'full-screen-window'"></svg-icon>
                <svg-icon
                    src="assets/images/call/window-x.svg"
                    (click)="callCenterMode = 'none'"></svg-icon>
            </div>
        </div>

        <div class="tab-content">
            <div
                class="tab-pane"
                [ngClass]="{ active: activeFloatTabI[0] }"
                @fadeInOut>
                <app-call-bar
                    *ngIf="
                        (callDetails$ | async)?.showOrderDetails ||
                        (callDetails$ | async)?.showAvailableAgents ||
                        (callDetails$ | async)?.showNewCallNote ||
                        (callDetails$ | async)?.showCallNotes
                    "></app-call-bar>
                <app-dialpad
                    [gatherInput]="inFocus"
                    *ngIf="
                        !(callDetails$ | async)?.showOrderDetails &&
                        !(callDetails$ | async)?.showAvailableAgents &&
                        !(callDetails$ | async)?.showNewCallNote &&
                        !(callDetails$ | async)?.showCallNotes
                    "></app-dialpad>
            </div>
            <div
                class="tab-pane"
                [ngClass]="{ active: activeFloatTabI[1] }"
                @fadeInOut>
                <input
                    type="search"
                    placeholder="Search by Phone Number"
                    class="search-text-input"
                    [ngClass]="{ loading: !(subs$ | async)?.closed }"
                    [(ngModel)]="searchPhoneNr"
                    (keyup)="loadCustomerCallsDebounce()"
                    (keyup.enter)="loadCustomerCalls()" />

                <app-inline-spinner
                    [isVisible]="!(subs$ | async)?.closed"
                    style="display: block; text-align: center"></app-inline-spinner>
                <div
                    class="no-results py-2 px-4"
                    *ngIf="(subs$ | async)?.closed && callLogs && callLogs.length === 0">
                    <p class="fs-6">No call records for the customer</p>
                </div>

                <div
                    class="call-log-cont my-1"
                    *ngIf="(subs$ | async)?.closed && callLogs.length > 0">
                    <div
                        class="d-flex flex-row item- w-100 my-2"
                        *ngFor="let callLog of callLogs">
                        <svg-icon
                            src="{{
                                callLog.contactId
                                    ? 'assets/images/call/known-user-icon.svg'
                                    : 'assets/images/call/unknown-user-icon.svg'
                            }}"></svg-icon>
                        <div
                            class="ms-1 hover"
                            (click)="doPhoneCallAction(callLog)">
                            <h1>
                                {{
                                    (callLog.direction !== 'out' ? callLog.callTo : callLog.callFrom)
                                        | replace : ' ' : ''
                                        | match : '(\\+?\\d+)' : 'gi'
                                        | head
                                        | formatPhone
                                }}
                            </h1>
                            <small>{{ callLog.firstname }} {{ callLog.surname }}</small>
                        </div>
                        <strong class="flex-grow-1 text-end">{{ callLog.duration | duration }}</strong>
                        <div
                            appDropdown
                            class="dropdown dropstart ys-dropdown-menu ms-3">
                            <span
                                class="hover"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <svg-icon src="assets/images/call/action-menu-icon.svg"></svg-icon>
                            </span>
                            <div class="dropdown-menu shadow-sm p-0 g-0">
                                <span class="dropdown-item text-primary py-2 disabled"> Lets call.. </span>
                                <span class="dropdown-item text-primary py-2 disabled"> Some future menu </span>
                                <span class="dropdown-item text-primary py-2 disabled"> Another menu </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="(subs$ | async)?.closed && callLogs && callLogs.length > 0"
                    class="btn btn-styled justify-content-center mb-4 mt-2"
                    (click)="callCenterMode = 'full-screen-window--calls'">
                    View All
                </div>
            </div>
            <div
                class="tab-pane"
                [ngClass]="{ active: activeFloatTabI[2] }"
                @fadeInOut>
                <div class="user-selector-holder">
                    <app-user-selector
                        [settingsData]="userSelectorSettings"
                        (usersSelected)="userSelected($event)"></app-user-selector>
                </div>
                <div
                    *ngIf="(subs$ | async)?.closed && contactList.length > 0"
                    class="btn btn-styled justify-content-center mb-4 mt-2"
                    (click)="callCenterMode = 'full-screen-window--contacts'">
                    View All
                </div>
            </div>
        </div>
    </div>
    <!--<div id="floating-callee-details" *ngIf="showCustomerDetails" @slideDetails>asas</div>-->
    <ng-template [ngTemplateOutlet]="orderDetailsTmpl"></ng-template>
    <ng-template [ngTemplateOutlet]="availableAgentsList"></ng-template>
    <ng-template [ngTemplateOutlet]="newCallNote"></ng-template>
    <ng-template [ngTemplateOutlet]="callNotes"></ng-template>
</ng-template>

<ng-template #orderDetailsTmpl>
    <div
        id="floating-callee-details"
        *ngIf="(callDetails$ | async)?.showOrderDetails"
        [ngClass]="callCenterMode"
        @slideDetails>
        <div
            class="d-flex justify-content-between header m-3"
            *ngIf="callCenterMode === 'floating-window'">
            <strong>{{ twilioService.onLinePhoneNr$$ | async | formatPhone }}</strong>
            <svg-icon
                class="hover"
                src="assets/images/call/window-x.svg"
                (click)="store.setProp('call', { showOrderDetails: false })"></svg-icon>
        </div>
        <div
            class="d-flex header m-3"
            *ngIf="callCenterMode === 'full-screen-window' || callCenterMode === 'bar-style'">
            <svg-icon
                class="me-1"
                src="assets/images/call/user-icon.svg"></svg-icon>
            <div>
                <h6 class="my-0 fs-sm fw-500">
                    <ng-container
                        *ngIf="
                            twilioService.onLineContact$$ | async;
                            then thenContact;
                            else elseContact
                        "></ng-container>
                    <ng-template #thenContact
                        >{{ (twilioService.onLineContact$$ | async).contactFirstname }}
                        {{ (twilioService.onLineContact$$ | async).contactSurname }}</ng-template
                    >
                    <ng-template #elseContact>Unknown</ng-template>
                </h6>

                <div style="line-height: 10px">
                    <span class="fs-xxs text-capitalize"
                        >&nbsp;{{ (twilioService.onLineContact$$ | async)?.accountType ?? '-' }}</span
                    >
                </div>
            </div>
            <strong class="flex-grow-1 text-end">{{ twilioService.onLinePhoneNr$$ | async | formatPhone }}</strong>
        </div>
        <div class="order-list-cont mx-3 mb-3 orders">
            <div
                *ngFor="let order of (callDetails$ | async)?.orders"
                class="mx-3">
                <div class="d-flex justify-content-between align-items-center py-1 header">
                    <h1>#ORD {{ order.publicId }}-{{ order.lineId }}</h1>
                    <span class="order-status-tag status-{{ order.status.id }}">{{ order.status.name }}</span>
                </div>
                <div class="d-flex mt-3 mb-5 align-items-center">
                    <div>
                        <h4>Due Date:</h4>
                        <h3>{{ order.dueDate | date : 'dd MMM yyyy' }}</h3>
                    </div>
                    <div class="mx-3">
                        <h4>Payemnt type:</h4>
                        <h3>{{ order.paymentMethodName ?? order.paymentMethod.id }}</h3>
                    </div>
                    <div class="flex-grow-1 text-end">
                        <strong>{{ order.net | currency : 'GBP' }}</strong>
                    </div>
                </div>
                <div
                    class="btn btn-styled mb-4 justify-content-center"
                    (click)="showOrderDetails(order.orderId)">
                    View Details
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #availableAgentsList>
    <div
        id="available-agents"
        class="d-flex flex-column"
        [ngClass]="callCenterMode"
        *ngIf="(callDetails$ | async)?.showAvailableAgents"
        @fadeInOut>
        <div class="header px-3 py-2">
            <input
                type="search"
                placeholder="Search by Name or Phone Number"
                class="search-text-input my-1"
                [ngClass]="{ loading: agentsList.length === 0 }"
                [(ngModel)]="agentFilter"
                (keyup)="filterAgentListDebounce(this.agentsList)"
                (keyup.enter)="filterAgentList(this.agentsList)" />
        </div>
        <div class="flex-grow-1 px-3 py-2 agent-list-cont">
            <mat-radio-group
                aria-label="Select an option"
                [(ngModel)]="redirect2Agent">
                <mat-radio-button
                    [value]="agent"
                    *ngFor="let agent of filteredAgentsList"
                    [checked]="redirect2Agent?.id === agent.id"
                    class="mb-3 mt-1">
                    <div class="d-flex w-100 ms-2">
                        <app-avatar
                            [user]="agent"
                            [fontSize]="'12px'"
                            [fontWeight]="'600'"
                            [showIcons]="false"
                            [onlineCb]="agentOnlineCb"></app-avatar>
                        <div class="d-flex flex-column flex-grow-1 justify-content-center ms-1">
                            <p class="m-0">{{ agent.firstname }} {{ agent.surname }}</p>
                            <small>{{ agent.accountType }}</small>
                        </div>
                    </div>
                </mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="d-flex justify-content-between px-3 py-2 footer">
            <a
                class="btn btn-styled--secondary my-1"
                (click)="store.setProp('call', { showAvailableAgents: false })"
                >Cancel</a
            >
            <a
                class="btn btn-styled my-1"
                (click)="redirectToAnotherAgent()"
                >Redirect call</a
            >
        </div>
    </div>
</ng-template>

<ng-template #newCallNote>
    <div
        id="new-call-note"
        class="d-flex flex-column"
        [ngClass]="callCenterMode"
        *ngIf="(callDetails$ | async)?.showNewCallNote"
        @fadeInOut>
        <div class="header px-3 py-2">
            <h4 class="fs-5 pt-1 lh-lg m-0">New Note</h4>
        </div>
        <div class="flex-grow-1 px-3 py-2 agent-list-cont">
            <label class="padded-top-gray-label">Note:</label>
            <editor
                [(ngModel)]="callNoteData.content"
                [apiKey]="this.env.tinymceApiKey"
                [init]="tinyInit"></editor>
            <label class="padded-top-gray-label">File:</label>

            <div
                class="dropzone dropzone-container"
                [dropzone]="uploadConfig"
                (error)="onUploadError($event)"
                (success)="onUploadSuccess($event)"
                (totalUploadProgress)="canPostANote = $event[0] === 100">
                <div
                    class="dz-message dz-message-sm mx-4"
                    data-dz-message>
                    <svg-icon
                        class="hover"
                        src="assets/images/image-upload.svg"></svg-icon>
                    <p>+ Select file <strong>from computer</strong> or use <strong>drag & drop</strong> (JPG,PNG)</p>
                </div>
                <div class="dz-details">
                    <div class="dz-filename"><span data-dz-name></span></div>
                    <div
                        class="dz-size"
                        data-dz-size></div>
                    <img data-dz-thumbnail />
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between px-3 py-2 footer">
            <a
                class="btn btn-styled--secondary my-1"
                (click)="store.setProp('call', { showNewCallNote: false })"
                >Cancel</a
            >
            <a
                class="btn btn-styled my-1"
                [ngClass]="{ disabled: !canPostANote }"
                (click)="addCallNote()"
                >Add Note</a
            >
        </div>
    </div>
</ng-template>

<ng-template #tooltipTemplate let-entry>
    <h6>Call log</h6>
    <div *ngFor="let log of entry.log">{{ log }}</div>
</ng-template>
<ng-template #callNotes>
    <div
        id="call-notes"
        class="d-flex flex-column"
        [ngClass]="callCenterMode"
        *ngIf="(callDetails$ | async)?.showCallNotes"
        @fadeInOut>
        <div class="header px-3 py-2">
            <h4 class="fs-5 pt-1 lh-lg m-0">Notes ({{ (callDetails$ | async).notes.length }})</h4>
        </div>
        <div class="flex-grow-1 px-3 py-2 notes-cont">
            <div
                *ngFor="let note of (callDetails$ | async).notes"
                class="pb-2">
                <label class="fs-xs mb-1"
                    >{{ note.createdBy.contact?.firstname }} {{ note.createdBy.contact?.surname }} ({{
                        note.createdAt | date : 'dd MMM yyyy @ HH:mm'
                    }})</label
                >
                <div
                    [innerHtml]="note.content | safeHTML"
                    class="fs-sm"></div>
                <ng-container *ngIf="note.files.length > 0">
                    <label class="fs-xs pt-2">Files:</label>
                    <div>
                        <ng-container *ngFor="let file of note.files; let i = index">
                            <a *ngIf="toolsService.isFileAnImage(file)"  target="_blank" href="{{ env.apiPath + 'notes/file/' + file }}"><img src="{{ env.apiPath + 'notes/file/' + file }}" width="30"/></a>
                            <a *ngIf="!toolsService.isFileAnImage(file)"  target="_blank" href="{{ env.apiPath + 'notes/file/' + file }}">{{ toolsService.getFileType(file) }}</a>&nbsp;
                        </ng-container>

                    </div>
                </ng-container>
            </div>
        </div>
        <div class="d-flex justify-content-between px-3 py-2 footer">
            <a
                class="btn btn-styled--secondary my-1"
                (click)="store.setProp('call', { showCallNotes: false })"
                >Cancel</a
            >
            <a
                class="btn btn-styled my-1"
                [ngClass]="{ disabled: !canPostANote }"
                (click)="toggleNewCallNote()"
                >Add Note</a
            >
        </div>
    </div>
</ng-template>

<ng-container>
    <div
        class="d-flex justify-content-center h-100 w-100 align-items-center spinner-container"
        *ngIf="!twilioService.disabled && !twilioService.isDeviceReady">
        <div
            class="spinner-grow text-secondary"
            role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div
        class="d-flex justify-content-center h-100 w-100 align-items-center ms-3"
        *ngIf="(twilioService.disabled || twilioService.isDeviceReady) && !twilioService.isLineBusy"
        @fadeInOut>
        <a
            class="btn btn-styled btn-styled--primary"
            [ngClass]="{ disabled: callCenterMode !== 'none' }"
            (click)="showDialer()">
            <svg-icon
                src="assets/images/call/dialer.svg"
                class="me-2"></svg-icon>
            Dialer</a
        >
    </div>
</ng-container>
